/**
 * Определяет название браузера из user agent
 * @returns Название браузера (Chrome, Firefox, Safari, Edge, Opera, Internet Explorer) или Unknown
 */
export const getBrowserName = (): string => {
  const userAgent = navigator.userAgent;

  if (userAgent.includes('Firefox/')) {
    return 'Firefox';
  } else if (userAgent.includes('Edg/')) {
    return 'Edge';
  } else if (userAgent.includes('Chrome/')) {
    return 'Chrome';
  } else if (userAgent.includes('Safari/') && !userAgent.includes('Chrome/')) {
    return 'Safari';
  } else if (userAgent.includes('Opera/') || userAgent.includes('OPR/')) {
    return 'Opera';
  } else if (userAgent.includes('MSIE') || userAgent.includes('Trident/')) {
    return 'Internet Explorer';
  }

  return 'Unknown';
};
